import { render, staticRenderFns } from "./LegalsView.vue?vue&type=template&id=cfba447e&"
import script from "./LegalsView.vue?vue&type=script&lang=js&"
export * from "./LegalsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports